import { ChartNoAxesCombined } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Outlet, useParams } from 'react-router-dom'
import { Container, SettingsPagesHeader } from '../../components'
import { UUID } from '@indigohive/cogfy-types'
import { useQuery } from '@tanstack/react-query'
import { useCogfy } from '../../hooks'

const MAP_URL_PARAMS_TO_TITLE = {
  'usage/overview': 'Overview usage',
  'usage/tasks': 'Tasks usage',
  'usage/credits': 'Credits usage',
  'usage/connections': 'Connections usage'
}

type Collection = { id: UUID, name?: string | null }

export type TasksHistoryChartProps = {
  collections: Collection[]
  collectionsLoading: boolean
}

export type WorkspaceUsageContext = {
  collections: Collection[]
  collectionsLoading: boolean
}

export function WorkspaceUsagePage () {
  const { t } = useTranslation()
  const cogfy = useCogfy()
  const params = useParams()

  const getCollections = useQuery({
    queryKey: ['getCollectionsByWorkspaceId'],
    queryFn: ({ signal }) => cogfy.getCollectionsByWorkspaceId({ type: 'database' }, { signal })
  })

  const context: WorkspaceUsageContext = {
    collections: getCollections.data ?? [],
    collectionsLoading: getCollections.isLoading
  }

  return (
    <>
      <SettingsPagesHeader
        title={t(MAP_URL_PARAMS_TO_TITLE[params['*'] as keyof typeof MAP_URL_PARAMS_TO_TITLE])}
        description={t('workspaceUsagePage:Gain insights into your workspace usage, including storage, tasks, credits, and connections')}
      >
        <ChartNoAxesCombined size={46} />
      </SettingsPagesHeader>
      <Container maxWidth='xl' className="mt-8">
        <Outlet context={context} />
      </Container>
    </>
  )
}
